import styled from 'styled-components'
import { INTRO_ACCENT_COLOR } from '~/pages/communication/intro/libs/components/IntroCommunication/constants'
import { BREAKPOINTS, COLORS } from '~/shared/constants/uiConstants'

const COMPACT = `@media (max-height: 660px)`

export const IntroCommunicationStyles = {
  Root: styled.div`
    width: 100%;
    height: calc(100dvh - var(--header-height));
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${COLORS.GRAY_100};
    overflow: hidden;
  `,

  ContentWrapper: styled.div`
    max-width: ${BREAKPOINTS[375]}px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: safe center;
    flex: 1;
    gap: 24px;
    padding: 24px 16px 150px;
    overflow: hidden;

    ${COMPACT} {
      padding: 24px 16px;
    }
  `,

  TitleGroup: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
  `,

  Title: styled.h1`
    font-size: 30px;
    font-weight: 700;
    line-height: 1.1;
    text-align: center;
    color: ${COLORS.BLACK};

    span {
      color: ${INTRO_ACCENT_COLOR};
      font-weight: inherit;
    }

    ${COMPACT} {
      font-size: 22px;
    }
  `,

  Subtitle: styled.p`
    font-size: 15px;
    font-weight: 400;
    line-height: 1.2;
    text-align: center;
    color: #17202a;

    ${COMPACT} {
      font-size: 13px;
    }
  `,

  Badges: styled.div`
    display: flex;
    gap: 12px;
    justify-content: center;
  `,

  Badge: styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    border-radius: 12px;
    background-color: #bbd7ff;
    font-family: 'Poppins', sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.4;
    color: ${INTRO_ACCENT_COLOR};
  `,

  Image: styled.img`
    flex: 1;
    max-height: min(360px, 45dvh);
    object-fit: contain;
    width: 100%;
  `,

  LoaderSection: styled.div`
    width: 100%;
  `,

  LoaderText: styled.p`
    font-size: 15px;
    font-weight: 700;
    line-height: 20px;
    text-align: center;
    color: ${COLORS.BLACK};
    margin-bottom: 8px;
  `,

  ProgressWrapper: styled.div`
    width: 100%;
    height: 16px;
    border-radius: 14px;
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c5d9fe;
  `,
}
